import { render, staticRenderFns } from "./FlatCard.vue?vue&type=template&id=771bdfae&"
import script from "./FlatCard.vue?vue&type=script&lang=ts&"
export * from "./FlatCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardActions})
